import VesselProperty from "./VesselProperty";

// This maps data key-values from Spire responses to `VesselProperty`s
const VesselSpireDataPropertyMap = {
	[VesselProperty.NAME]: "name",
	[VesselProperty.IMO]: "imo",
	[VesselProperty.MMSI]: "mmsi",
	[VesselProperty.TIMESTAMP]: "timestamp", // mid-end maps this from vessel["last_known_position"]["timestamp"]
	[VesselProperty.CLASSIFICATION]: "ship_type", // "classification",
	[VesselProperty.FLAG]: "flag",
	[VesselProperty.DRAUGHT]: "draught",
	[VesselProperty.SPEED]: "speed",
	[VesselProperty.VOYAGE_DESTINATION]: "voyage_dest",
	[VesselProperty.VOYAGE_ETA]: "voyage_eta",
	[VesselProperty.COURSE]: "course",
	[VesselProperty.HEADING]: "heading",
	[VesselProperty.UPDATE]: "update", // always "" from mid-end.
	[VesselProperty.CALL_SIGN]: "call_sign",
	[VesselProperty.WIDTH]: "width",
	[VesselProperty.LENGTH]: "length",
	[VesselProperty.CREATED_AT]: "created_at_timestamp",
	[VesselProperty.UPDATED_AT]: "updated_at_timestamp",
	[VesselProperty.STATIC_UPDATE_AT]: "static_updated_at_timestamp",
	[VesselProperty.SPIRE_ID]: "vessel_id",
	[VesselProperty.EXTRA]: "extra"
};
export default VesselSpireDataPropertyMap;
